<template>
  <div>
    <h3>Test-Component</h3>
    <v-btn v-if="true" flat color="blue" v-on:click="ui_event('Test 1')">
      Test 1
    </v-btn>
    <v-btn v-if="true" flat color="blue" v-on:click="ui_event('Export Moodle Test')">
      Export Moodle Test
    </v-btn>
<v-btn v-if="true" flat color="blue" v-on:click="ui_event('Test Odata')">
      Test Odata
    </v-btn>

    <v-btn v-if="true" flat color="blue" v-on:click="ui_event('Test VideoAI')">
      Test Video AI
    </v-btn>

    <download-excel
  class="btn btn-default"
  :data="json_data"
  :fields="json_fields"
  worksheet="My Worksheet"
  name="filename.xls"
>
  Download Excel (you can customize this with html code!)
</download-excel>

  <div v-for="line in lines" :key="line">
    {{line}}
    </div>

  </div>
</template>

<script>
import "firebase/firestore";
import { FirebaseTable } from "./../table/FirebaseTable.js";
import { create_moodle_xml } from "./../quiz/Moodle.js";
import axios from "axios";

export default {
  data() {
    return {
      components: {},
      baseUrl: process.env.BASE_URL,
      fbTable: {},

      ui_show_odata : false,

      lines: ["Ausgabe : "],

      json_fields: {
        "Complete name": "name",
        City: "city",
        Telephone: "phone.mobile",
        "Telephone 2": {
          field: "phone.landline",
          callback: (value) => {
            return `Landline Phone - ${value}`;
          },
        },
      },

      json_data: [
        {
          name: "Tony Peña",
          city: "New York",
          country: "United States",
          birthdate: "1978-03-15",
          phone: {
            mobile: "1-541-754-3010",
            landline: "(541) 754-3010",
          },
        },
        {
          name: "Thessaloniki",
          city: "Athens",
          country: "Greece",
          birthdate: "1987-11-23",
          phone: {
            mobile: "+1 855 275 5071",
            landline: "(2741) 2621-244",
          },
        },
      ],

      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },

  computed: {
    userName() {
      console.log("Store call back");
      return this.$store.state.currentUser;
    },
  },

  methods: {
    async list_sap_entries() {
      var list = await this.fbTable.get_lines("SAP_S4");
      list.forEach((account) => {
        console.log(account.email, ", ", account.account);
      });
    },

    async ui_event(event) {
      // console.log("uiEvent : " + event);
      // Process events, that do not need store call

      var tName = "XY_Test";
      let url, config;
      //var tName = "Quiz";
      var r = 1;
      switch (event) {
        case "Test Odata":
          url =
            "https://r36z.ucc.ovgu.de/sap/opu/odata/sap/ZBV_TEST_SRV/PRICESet('DXTR3999')";
          config = {
            headers: {
              "content-type": "application/json",           
            },
            auth: {
              username: 'bv_master',
              password: 'maihiro'
            }
          };

          axios
            .get(url, config)
            .then((R) => {
              console.log("Intent / Response : " );
              console.log("VKORG  : " , R.data.d.VKORG);
              console.log("VTWEG  : " , R.data.d.VTWEG);
              console.log("CUR    : " , R.data.d.CUR);
              console.log("KBETR  : " , R.data.d.KBETR);
            })
            .catch((error) => {
              console.log("Error : " + JSON.stringify(error));
            });

          return;

        case "Test 1": // return to landing page
          // r = this.fbTable.create_test_table( )
          //r =  await this.fbTable.get_lines( tName)

          //var x = await this.fbTable.get_count(tName);
          //r = await this.fbTable.set_count(tName);
          this.list_sap_entries();
          console.log("Result of Test 1 a  : ", r);
          return;

      

        case "Test VideoAI":
          break;
          

        case "cancel": // return to landing page
          this.$router.push({ name: "Landing" });
          return;
      }
    },
  },

  beforeCreate() {
    console.log("Lifecycle Hook: before create");
  },

  created() {
    console.log("Lifecycle Hook: created");
    this.fbTable = new FirebaseTable();
  },

  beforeMount() {
    console.log("Lifecycle Hook: beforeMount");
  },

  mounted() {
    this.fbTable = new FirebaseTable("Test1");
  },

  beforeUpdate() {
    console.log("Lifecycle Hook: beforeUpdate");
  },

  beforeDestroy() {
    console.log("Lifecycle Hook: beforeDestroy");
  },

  // Router Links
  // https://router.vuejs.org/guide/advanced/navigation-guards.html#in-component-guards
  beforeRouteEnter(to, from, next) {
    console.log("Router Hook: before route enter");
  },

  beforeRouteUpdate(to, from, next) {
    console.log("Router Hook: before route update");
  },

  beforeRouteLeave(to, from, next) {
    console.log("Router Hook: before route leave");
  },
};
</script>

<style scoped>
</style>
